import { updateSessionState } from 'app/lib/axios/session-state';
import { storage } from 'app/lib/storage';
import { StorageKey } from 'app/lib/storageKeys';

const LOGIN_AS_EMAIL_PATTERN = /^(.+) -> (.+)$/;

export async function prepareLoginAsEmail(email: string): Promise<string> {
  const match = LOGIN_AS_EMAIL_PATTERN.exec(email);
  if (match?.length !== 3) return email;

  const [, rawEmail = '', rawLoginAsEmail = ''] = match;
  const loginAsEmail = rawLoginAsEmail.trim();
  await Promise.allSettled([
    storage.clear(StorageKey.LoginAsUserId),
    storage.saveString(StorageKey.LoginAsEmail, loginAsEmail),
  ]);
  updateSessionState({ loginAsUserId: null, loginAsEmail });

  return rawEmail.trim();
}
